<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Vínculos">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-6">
        <label for="nome">Departamento</label>
        <br />
        <div class="input-group input-focus">
          <a-auto-complete v-model:value="filtros.departamento.nome" style="width: 200px" @search="pesquisarDepartamentos" class="form-control border-left-0">
            <template v-slot:dataSource>
              <a-select-option v-for="item in departamentos" :key="item.nome" @click="onSelect(item, 'DEPARTAMENTO')">
                {{ item.nome }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>

      <div class="col-md-6">
        <label>Médicos</label>
        <br />
        <div class="input-group input-focus">
          <a-auto-complete v-model:value="filtros.medico.nome" style="width: 200px" @search="pesquisarMedicos" class="form-control border-left-0">
            <template v-slot:dataSource>
              <a-select-option v-for="item in medicosFiltro" :key="item.nome" @click="onSelect(item, 'MEDICO')">
                {{ item.nome }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-6" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px"><i class="fa fa-plus"> </i> Criar novo</button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #prazo="{ record }">
        {{ record.prazo + ' meses' }}
      </template>
      <template #action="{ record }">
        <a @click="visualizar(record)">
          <i class="fas fa-eye icon-trash"></i>
        </a>
        &nbsp;&nbsp;
        <a title="Excluir" @click="excluir(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
  <Dialog
    header="Detalhes do Vínculo"
    v-model:visible="showDialog"
    style="
       {
        backgroundcolor: #dcdeff;
      }
    "
    id="showDialog"
  >
    <div class="row">
      <div><label style="margin-left: 1px; font-weight: bold">Departamento: </label> {{ this.objetoSelecionado.departamento.nome }}</div>
      <div><label style="margin-left: 1px; font-weight: bold">Status: </label> {{ this.objetoSelecionado.situacao }}</div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div>
        <a-table :dataSource="objetoSelecionado.medicos" :columns="columnsTableVisualizacao" :key="this.objetoSelecionado.id"> </a-table>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteById, getLista, create } from '@/components/service/vinculoDepartamentoMedicoService';

import { getListaDepartamento } from '@/components/service/departamentoService';
import { getListaProfissionaisResumida } from '@/components/service/profissionalService';

export default {
  name: 'PageListarVinculoDepartamentoMedico',
  data() {
    return {
      nomePagina: 'Vínculo Departamento',
      situacao: 'TODOS',
      nome: undefined,
      objetoSelecionado: undefined,
      filtros: { departamento: { id: null, nome: null }, medico: { id: null, nome: null } },
      departamentos: [],
      medicos: [],
      medicosFiltro: [],
      lista: [],
      showDialog: false,
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Departamento',
          dataIndex: 'departamento.nome',
          key: 'departamento.nome',
          slots: { customRender: 'departamento.nome' },
        },

        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsTableVisualizacao: [
        {
          title: 'Médico',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },
      ],
    };
  },
  methods: {
    excluir(record) {
      deleteById(record.id)
        .then(() => {
          openNotification(typesNotification.success, this.nomePagina + ' excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir ' + this.nomePagina.toLowerCase() + '!');
        });
    },
    editar(record) {
      this.$router.push({ path: '/form-vinculo-departamento-medico', query: { id: record.id } });
    },
    visualizar(record) {
      this.objetoSelecionado = record;
      this.showDialog = true;
    },
    criarNova() {
      this.$router.push('form-vinculo-departamento-medico');
    },
    async toggleSituacao(record) {
      const novoStatus = record.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      const novoRecord = { ...record, situacao: novoStatus };
      await create(novoRecord);
      this.lista.find((i) => i.id == record.id).situacao = novoStatus;
      openNotification(typesNotification.success, 'Status do ' + this.nomePagina.toLowerCase() + ' alterado com sucesso!');
    },

    async toggleSituacaoSubObjeto(record) {
      const novoStatus = record.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      this.objetoSelecionado.departamentos.find((i) => i.id == record.id).situacao = novoStatus;
      await create(this.objetoSelecionado);
      openNotification(typesNotification.success, 'Status da ' + this.nomePagina.toLowerCase() + ' alterado com sucesso!');
    },
    async pesquisar() {
      getLista(this.filtros)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de ' + this.nomePagina.toLowerCase() + ' cadastrados!');
        });
    },
    async pesquisarDepartamentos(value) {
      if (value.length >= 2) {
        let filtros = { situacao: 'ATIVO', nome: value };
        await getListaDepartamento(filtros).then((response) => {
          this.departamentos = response.data;
        });
      }
    },
    async pesquisarMedicos(value) {
      if (value.length >= 2) {
        this.medicosFiltro = this.medicos.filter((e) => e.nome.toUpperCase().includes(value.toUpperCase()));
      }
    },
    async carregarMedicos() {
      await getListaProfissionaisResumida().then((p) => {
        this.medicos = p.data;
      });
    },
    onSelect(value, nome) {
      switch (nome) {
        case 'DEPARTAMENTO':
          this.filtros.departamento = { id: value.id, nome: value.nome };
          break;
        case 'MEDICO':
          this.filtros.medico = { id: value.id, nome: value.nome };
          break;
      }
    },
  },
  created() {
    this.pesquisar();
    this.carregarMedicos();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
